import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, LOCALE_ID, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Message, ConfirmationService, ConfirmEventType, MenuItem, MessageService } from 'primeng/api';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { HeaderComponent } from 'src/app/admin/layout/header/header.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextEditorQuestion } from 'src/app/misc/component/dynamic-form/question-editor';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { link, breadcrumb, stat } from '../../layout/header/header.component';
import { TimePickerQuestion } from 'src/app/misc/component/dynamic-form/question-timepicker';
import { RadioButtonQuestion } from 'src/app/misc/component/dynamic-form/question-radiobutton';
import { TextAreaQuestion } from 'src/app/misc/component/dynamic-form/question-textarea';
import { CheckBoxQuestion } from 'src/app/misc/component/dynamic-form/question-checkbox';
import { DatePipe, formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { SurveyAssessment } from 'src/app/misc/enums/survey-assessment.enum';
import { QuestionBankComponent } from './question-bank/question-bank.component';
import { functionLink } from 'src/app/misc/component/dynamic-form/question-functionLink';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { TreeNode } from 'primeng/api';


@Component({
  selector: 'app-assessment',
  templateUrl: './assessment.component.html',
  styleUrl: './assessment.component.scss'
})
export class AssessmentComponent {
  skelition = true;
  expandedFilters: Set<string> = new Set(['ou', 'qb']);

  @Input() assessmentTypeId: string = '';
  @Input() fromTraining: boolean = false;
  @Input() trainingTypeId: string = "";

  @Output() newAssess = new EventEmitter<any>();

  @Input() updateAssesData: any;

  @Output() updateAssesment = new EventEmitter<any>();

  @ViewChild(QuestionBankComponent) QuestionBankComponent: QuestionBankComponent | any;
  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;
  @ViewChild(HeaderComponent) HeaderComponent: HeaderComponent | undefined;
  messages: Message[] = [];
  menuItems: MenuItem[] = [
    {
      label: '<span class="mx-3">تعديل</span>',
      escape: false,
      icon: 'pi pi-refresh',
      command: () => {
        this.assessmentActionCall({ id: this.operationAssessment._id, action: 'Update' })
      }
    },
    {
      label: '<span class="mx-3">حذف</span>',
      escape: false,
      icon: 'pi pi-fw pi-trash',
      command: () => {
        this.assessmentActionCall({ id: this.operationAssessment._id, action: 'Delete' })
      }
    }
  ];

  header = this.translate('Assessments');
  links: link[] = [
    // {
    //   name: this.translate('Add Topic'),
    //   icon: 'pi pi-plus',
    //   link: '/assessment/topics',
    //   visible: this.hasPermission('GENERAL_TOPIC', 'a')
    // },
    {
      name: this.translate('Add Standard Question Bank'),
      icon: 'pi pi-plus',
      link: '/assessment',
      queryParams: { 'QBankId': '65f71c25cf3086b3277d7f2d', 'tabIndex': 1 },
      visible: this.hasPermission('GENERAL_QB', 'a')
    },
    {
      name: this.translate("Tags Management"),
      icon: 'pi pi-plus',
      link: '/assessment/tags-management',
      visible: this.hasPermission('SURVEY_TAGS', 'c') || this.hasPermission('SURVEY_TAGS', 'u') || this.hasPermission('SURVEY_TAGS', 'd')
    },
    // {
    //   name: this.translate("Create Assessment From PDF"),
    //   icon: 'pi pi-plus',
    //   link: '/assessment/pdf-assessment',
    // },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Assessments'), link: '/assessment' },
  ];
  queryParams: any = {};
  stats: stat[] = [];
  translator: TranslatorPipe = new TranslatorPipe()
  page: number = 1;
  rows: number = 10;
  first = 1;

  totalDocuments: number = 0;
  assessments: any[] = [];
  types: any[] = [];
  operationAssessment: any;
  statusOptions: string[] = ['Draft', 'Pending', 'Active', 'Closed']
  questions: QuestionBase<string>[] = [];
  allowedTags: string[] = this.permissionService.extractTags('ASSESSMENT_TAGS', 'r')
  allTags: any[] = [];
  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  openCreateModal: boolean = this.fromTraining;
  checkboxValue: boolean = false;
  selectedAssessments: any[] = []
  operationType: any;
  templateSelectionList: any[] = [];

  //Question Bank
  questionBankService: any[] = [];
  questionBankTopics: any[] = [];
  currentQBank: any;
  currentQBankId: string = "";
  questionBanks: any[] = [];
  standardQBs: any[] = [];

  activeTabIndex: number = 0;

  sortField: string = '';
  sortDirection: string = 'desc';
  topics: any[] = [];

  standardQBID: string = '65f71c25cf3086b3277d7f2d';
  ministries: any[] = [];
  clonedAssessment: any = {};
  isCopy: string = 'false';
  questionBanksAll: any[] = [];
  searchText: string = '';

  // Filters
  selectedOU: any = null;
  selectedMinistry: any = null;  // First dropdown - Ministry/Entity
  selectedDepartment: any = null;  // Second dropdown - Department/Division/Branch
  availableOus: any[] = [];
  availableOus_original: any[] = [];
  availableMinistries: any[] = [];  // Top level ministries/entities for first dropdown
  availableDepartments: any[] = [];  // Children of selected ministry for second dropdown
  availableTags: any[] = [];
  filteredQuestionBanks: any[] = [];
  loadingPaths: boolean = false;
  preserveFilteredQBs: boolean = false;  // Flag to preserve filtered question banks
  staticURL = GlobalConstants.staticFilesURL;
  readonly DESIGNATION_ORG_TYPE_ID = '6469296b87f9e1cc8aa233c6';
  statusFilter: string | null = null;

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    @Inject(LOCALE_ID) private locale: string,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private messageService: MessageService,
    private ouService: OrgUnitsService,
    private cdr: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    this.skelition = true;
    // First fetch tags and question banks
    await Promise.all([
      this.getAssessmentTags(),
      this.getAllQuestionBanks()
    ]);
    
    // Then fetch and filter OUs based on the user's tags
    await this.fetchOus();
    
    console.log("asd", this.skelition);
    const savedTabIndex = localStorage.getItem('activeTabIndex');
    if (savedTabIndex !== null) {
      this.activeTabIndex = +savedTabIndex;
    }
    this.makequestion();
    console.log('ALL TAGS', this.allTags);
    console.log('ALL QuestionBanks', this.questionBanks);
    this.filterQuestionBanks();

    this.activatedRouter.queryParams.subscribe(async params => {
      if (params['page'] && params['rows']) {
        this.page = Number(params['page']);
        this.rows = Number(params['rows']);
      }

      console.log("Rows", this.rows);
      console.log("New Page", this.page);

      if (params['QBankId']) {
        this.currentQBankId = params['QBankId'];
      }
      if (params['tabIndex']) {
        const savedTabIndex = +params['tabIndex'];
        if (!isNaN(savedTabIndex)) {
          this.activeTabIndex = savedTabIndex;
        }
      }
      this.queryParams = { 'QBankId': this.currentQBankId, 'tabIndex': this.activeTabIndex };
      this.skelition = true;
      await this.getQuestionBanks()
        .then(async () => Promise.all([await this.getStandardQB(), await this.fetchTopics()]))
        .then(() => {
          this.skelition = false;
        })
        .catch((error) => {
          console.error('Error loading data:', error);
          this.skelition = false;
        });
    })

  }
  async fetchOus() {
    this.availableOus_original = await this.ouService.getOrgUnits();
    // Filter OUs to only show those that have tags the user has permission for
    await this.filterOusByUserTags();
    // Populate ministries dropdown (top level only, no children)
    this.populateMinistries();
  }

  populateMinistries() {
    // Collect only actual ministries/entities - not the container nodes like "وزارات" or "كيانات"
    // These are nodes with tag 'Ministries/Entities' that have NO children with the same tag
    
    this.availableMinistries = [];
    
    if (!this.availableOus || this.availableOus.length === 0) {
      return;
    }
    
    // Collect leaf-level ministries/entities (not containers)
    this.availableMinistries = this.collectActualMinistries(this.availableOus);
    
    console.log('Available Ministries:', this.availableMinistries);
  }

  collectActualMinistries(nodes: any[]): any[] {
    let collected: any[] = [];
    
    for (const node of nodes) {
      const nodeTag = node.tag;

      
      if (nodeTag === 'Ministries/Entities') {
        // Check if this node has any children that are also Ministries/Entities
        // If yes, it's a container - skip it and process children
        // If no, it's an actual ministry/entity - include it
        const hasMinistryChildren = node.children?.some((child: any) => child.tag === 'Ministries/Entities');
        
        if (hasMinistryChildren) {
          // Include the container itself and also collect its ministry children
          collected.push({
            ...node,
            children: node.children
          });
          collected = collected.concat(this.collectActualMinistries(node.children));
        } else {
          // This is an actual ministry/entity
          collected.push({
            ...node,
            children: node.children // Include children as they may contain departments/branches
          });
        }
      } else if (node.children && node.children.length > 0) {
        // Keep searching in children
        collected = collected.concat(this.collectActualMinistries(node.children));
      }
    }
    
    return collected;
  }

  onMinistryChange() {
    // Reset department selection when ministry changes
    this.selectedDepartment = null;
    this.selectedOU = null;
    this.availableDepartments = [];
    
    if (this.selectedMinistry) {
      // Find the full node with children from the tree
      const ministryId = this.selectedMinistry._id || this.selectedMinistry.key;
      
      // Search in availableOus first (filtered tree), then original
      //let fullNode = this.findNodeInTree(this.availableOus, ministryId);

      let fullNode = this.findNodeInTree(this.availableOus_original, ministryId);
      
      // if (!fullNode || !fullNode.children || fullNode.children.length === 0) {
      //   fullNode = this.findNodeInTree(this.availableOus_original, ministryId);
      // }
      
      if (fullNode && fullNode.children && fullNode.children.length > 0) {
        // Filter to show departments and branches, exclude designations and content
        this.availableDepartments = this.filterChildrenForTree(fullNode.children);
      } else {
        this.availableDepartments = [];
      }
      
      // Set selectedOU to ministry for filtering
      this.selectedOU = this.selectedMinistry;
    }
    
    // Trigger filter change
    this.onOUFilterChange();
  }

  filterChildrenForTree(children: any[]): any[] {
    // Include only departments and branches, exclude designations and content
    // Designations (EXCLUDE): org-type _id = DESIGNATION_ORG_TYPE_ID (المسمى الوظيفي)
    // Content Related (EXCLUDE): tag = "Content Related"
    
    let result: any[] = [];
    
    for (const child of children) {
      const childTag = child.tag || '';
      
      // Exclude Content Related
      if (childTag === 'Content Related') {
        continue;
      }
      
      // Exclude designations (identified by org-type)
      if (child.orgTypeId === this.DESIGNATION_ORG_TYPE_ID) {
        continue;
      }
      
      // Only include Organisational Structure and Branches
      if (childTag !== 'Organisational Structure' && childTag !== 'Branches') {
        continue;
      }
      
      // Create a copy of the node
      const nodeCopy = { ...child };
      
      // Recursively filter children
      if (child.children && child.children.length > 0) {
        nodeCopy.children = this.filterChildrenForTree(child.children);
        if (nodeCopy.children.length === 0) {
          nodeCopy.children = undefined;
        }
      } else {
        nodeCopy.children = undefined;
      }
      
      result.push(nodeCopy);
    }
    
    return result;
  }

  onDepartmentChange() {
    if (this.selectedDepartment) {
      // Set selectedOU to the selected department for filtering
      this.selectedOU = this.selectedDepartment;
    } else if (this.selectedMinistry) {
      // If no department selected, use ministry
      this.selectedOU = this.selectedMinistry;
    } else {
      this.selectedOU = null;
    }
    
    // Trigger filter change
    this.onOUFilterChange();
  }

  async filterOusByUserTags() {
    // Get all OUs that have tags the user has access to
    const ouIdsWithTags = new Set<string>();
    
    // Collect OU IDs from the user's allowed tags
    for (const tag of this.allTags) {
      if (tag.ou) {
        const ouId = tag.ou._id || tag.ou;
        if (ouId) {
          ouIdsWithTags.add(ouId);
        }
      }
    }

    // If user has MASTER_TAG, show all OUs with Ministries/Entities tag
    if (this.allowedTags.includes('MASTER_TAG')) {
      this.filterTreeByTag(['Ministries/Entities']);
    } else if (ouIdsWithTags.size > 0) {
      // Filter tree to only show OUs that have tags the user has access to
      this.filterTreeByOuIds(ouIdsWithTags);
    } else {
      this.availableOus = [];
    }
  }

  filterTreeByOuIds(ouIds: Set<string>) {
    this.availableOus = cloneDeep(this.availableOus_original);
    this.availableOus = this.availableOus
      .map((node: any) => this.filterNodesByOuIds(node, ouIds))
      .filter((filteredNode: any) => filteredNode !== null);
  }

  filterNodesByOuIds(node: any, ouIds: Set<string>): any | null {
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodesByOuIds(childNode, ouIds))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include node if its ID is in the allowed set or if it has matching children
    if (ouIds.has(node._id) || (node.children && node.children.length > 0)) {
      return node;
    }

    return null;
  }

  filterTreeByTag(tags: string[]) {
    this.availableOus = cloneDeep(this.availableOus_original);
    this.availableOus = this.availableOus
      .map((node: any) => this.filterNodes(node, tags))
      .filter((filteredNode: any) => filteredNode !== null);
  }

  filterNodes(node: any, tags: string[]): any | null {
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tags))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    if (tags.includes(node.tag) || (node.children && node.children.length > 0)) {
      return node;
    }

    return null;
  }

  onOUFilterChange() {
    const selectedNode = this.selectedOU;
    
    // Deselect current path when OU changes
    this.currentQBank = null;
    this.currentQBankId = "";
    this.preserveFilteredQBs = false;  // Reset the preserve flag
    
    // Show loader
    this.loadingPaths = true;
    this.cdr.detectChanges();  // Force UI update to show loader
    
    // Use setTimeout to ensure loader is rendered before filtering
    setTimeout(() => {
      try {
        if (selectedNode) {
          const selectedId = selectedNode._id || selectedNode.key;
          console.log('Selected OU:', selectedNode, 'ID:', selectedId);
          
          // Find the full node with children from the original tree
          const fullNode = this.findNodeInTree(this.availableOus_original, selectedId);
          console.log('Full node with children:', fullNode);
          
          // Get the selected OU ID and all its children IDs
          const allOuIds = fullNode ? this.collectAllOuIds(fullNode) : [selectedId];
          console.log('All OU IDs to filter by:', allOuIds);
          
          // Filter tags locally instead of making API calls
          this.filterTagsByOuIds(allOuIds);
        } else {
          // If no OU selected, show all tags
          this.availableTags = [...this.allTags];
        }
        // Filter question banks based on filtered tags
        this.filterQuestionBanksByOuTags();
      } finally {
        this.loadingPaths = false;
        this.cdr.detectChanges();  // Force UI update to hide loader
      }
    }, 50);  // Small delay to show loader
  }

  // Filter tags locally by OU IDs (no API calls needed)
  filterTagsByOuIds(ouIds: string[]) {
    console.log('Filtering tags locally by OU IDs:', ouIds);
    
    // Filter allTags to only include tags that belong to the selected OUs
    this.availableTags = this.allTags.filter((tag: any) => {
      const tagOuId = tag.ou?._id || tag.ou;
      return ouIds.includes(tagOuId);
    });
    
    console.log('Filtered tags:', this.availableTags);
  }

  // Find a node by ID in the tree structure
  findNodeInTree(nodes: any[], targetId: string): any | null {
    for (const node of nodes) {
      const nodeId = node._id || node.key;

      if (nodeId === targetId) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        const found = this.findNodeInTree(node.children, targetId);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  // Collect the selected OU ID and all its children IDs recursively
  collectAllOuIds(node: any): string[] {
    const ids: string[] = [];
    const nodeId = node._id || node.key;
    if (nodeId) {
      ids.push(nodeId);
    }
    if (node.children && node.children.length > 0) {
      for (const child of node.children) {
        ids.push(...this.collectAllOuIds(child));
      }
    }
    return ids;
  }

  // Fetch tags for multiple OUs and combine results
  async getAssessmentTagsForMultipleOus(ouIds: string[]) {
    console.log('Fetching tags for OUs:', ouIds);
    try {
      // Fetch tags for all OUs in parallel
      const tagPromises = ouIds.map(ouId => 
        this.dataService.getData(`survey-tags/ASSESSMENT?ou=${ouId}`)
      );
      
      const results = await Promise.all(tagPromises);
      
      // Combine all tags from all OUs
      const combinedTags: any[] = [];
      const tagIds = new Set<string>();
      
      for (const res of results) {
        if (!res.error && res.data) {
          for (const tag of res.data) {
            // Avoid duplicates
            if (!tagIds.has(tag._id)) {
              tagIds.add(tag._id);
              combinedTags.push({
                _id: tag._id,
                label: tag.arabic,
                arabic: tag.arabic,
                value: tag.tag,
                ou: tag.ou,
                questionbanks: tag.questionbanks || []
              });
            }
          }
        }
      }
      
      this.availableTags = combinedTags;
      console.log('Combined tags from all OUs:', this.availableTags);
    } catch (e) {
      console.log(e);
      this.availableTags = [];
    }
  }

  /** Tags with no linked OU display as "All" in tag management; paths on these tags apply when no OU filter is selected. */
  private tagIsLinkedToAllOus(tag: any): boolean {
    const ou = tag?.ou;
    if (ou == null || ou === undefined) return true;
    const id = typeof ou === 'object' && ou !== null ? ou._id : ou;
    return id == null || id === '';
  }

  filterQuestionBanksByOuTags() {
    // If we should preserve the current filtered question banks, don't re-filter
    if (this.preserveFilteredQBs && this.filteredQuestionBanks.length > 0) {
      console.log('Preserving current filtered question banks');
      return;
    }
    
    console.log('Filtering question banks. Available tags:', this.availableTags.length);
    
    if (this.selectedOU) {
      // OU is selected - filter based on tags for that OU
      const selectedId = this.selectedOU._id || this.selectedOU.key;
      const fullNode = this.findNodeInTree(this.availableOus_original, selectedId);
      const allOuIds = fullNode ? this.collectAllOuIds(fullNode) : [selectedId];
      
      // Collect question banks from filtered tags
      const qbsFromTags = new Set<string>();
      const tagIds = new Set<string>();
      
      this.availableTags.forEach((tag: any) => {
        tagIds.add(tag._id);
        if (tag.questionbanks && tag.questionbanks.length > 0) {
          tag.questionbanks.forEach((qb: any) => {
            qbsFromTags.add(qb._id);
          });
        }
      });

      // First: Use question banks directly from tags (fastest)
      if (qbsFromTags.size > 0) {
        const qbsFromTagsDirect: any[] = [];
        this.availableTags.forEach((tag: any) => {
          if (tag.questionbanks && tag.questionbanks.length > 0) {
            qbsFromTagsDirect.push(...tag.questionbanks);
          }
        });
        // Remove duplicates
        const seen = new Set<string>();
        this.filteredQuestionBanks = qbsFromTagsDirect.filter(qb => {
          if (seen.has(qb._id)) return false;
          seen.add(qb._id);
          return true;
        });
      } else {
        // Fallback: Filter from questionBanksAll by OU IDs
        this.filteredQuestionBanks = this.questionBanksAll.filter(qb => {
          const qbTagOUId = qb.tag?.ou?._id || qb.tag?.ou;
          return allOuIds.includes(qbTagOUId) || tagIds.has(qb.tag?._id);
        });
        
        // If still empty, try from questionBanks
        if (this.filteredQuestionBanks.length === 0) {
          this.filteredQuestionBanks = this.questionBanks.filter(qb => {
            const qbTagOUId = qb.tag?.ou?._id || qb.tag?.ou;
            return allOuIds.includes(qbTagOUId) || tagIds.has(qb.tag?._id);
          });
        }
      }
    } else {
      // No OU selected — show paths linked to "All" tags (no OU on the tag)
      const globalQbIds = new Set<string>();
      this.allTags.forEach((tag: any) => {
        if (!this.tagIsLinkedToAllOus(tag)) return;
        (tag.questionbanks || []).forEach((qb: any) => {
          if (qb?._id) globalQbIds.add(String(qb._id));
        });
      });
      if (globalQbIds.size > 0) {
        this.filteredQuestionBanks = this.questionBanksAll.filter(
          qb => globalQbIds.has(String(qb._id)) && qb._id !== this.standardQBID
        );
      } else {
        const qbIdsInTable = new Set(
          this.assessments.map(a => a.questionBankId).filter(Boolean).map(id => String(id))
        );
        this.filteredQuestionBanks = this.questionBanks.filter(qb => qbIdsInTable.has(String(qb._id)));
      }
    }
    
    console.log('Filtered question banks (paths):', this.filteredQuestionBanks.length);
  }

  async clearFilters() {
    this.selectedOU = null;
    this.selectedMinistry = null;
    this.selectedDepartment = null;
    this.availableDepartments = [];
    this.currentQBankId = "";
    this.currentQBank = null;
    this.preserveFilteredQBs = false;  // Reset the preserve flag

    // Explicitly navigate and refresh data
    await this.router.navigate(['/assessment']);

    this.skelition = true;
    // Refresh tags for all OUs
    await this.getAssessmentTags();
    await this.getQuestionBanks()
      .then(() => {
        this.filterQuestionBanks();
        this.skelition = false;
      })
      .catch((error) => {
        console.error('Error refreshing data:', error);
        this.skelition = false;
      });
  }

  refreshPage() {
    // Navigate to assessment page and reload to get initial state
    window.location.href = '/assessment';
  }

  openAddQBModal() {
    if (!this.isFilterExpanded('qb')) {
      this.toggleFilter('qb');
    }

    setTimeout(() => {
      if (this.QuestionBankComponent) {
        this.QuestionBankComponent.openCreateModal = true;
      }
    });
  }

  toggleFilter(filterName: string) {
    if (this.expandedFilters.has(filterName)) {
      this.expandedFilters.delete(filterName);
    } else {
      this.expandedFilters.add(filterName);
    }
  }

  isFilterExpanded(filterName: string): boolean {
    return this.expandedFilters.has(filterName);
  }

  filterQuestionBanks() {
    // Use the same logic as filterQuestionBanksByOuTags
    this.filterQuestionBanksByOuTags();
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }


  openAddQuestionsPage(assessment: any) {
    this.router.navigate(['/assessment/add-question/', assessment._id], {
      queryParams: {
        QBankId: this.currentQBankId ? this.currentQBankId : assessment.questionBankId,
        tabIndex: this.activeTabIndex,
      }
    })
  }

  openResultsPage(assessment: any) {
    this.router.navigate(['/assessment/results/', assessment._id], {
      queryParams: {
        QBankId: this.currentQBankId ? this.currentQBankId : assessment.questionBankId,
        tabIndex: this.activeTabIndex,
        Main: 1
      }
    })
  }

  async ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange['fromTraining']) {
      this.openCreateModal = this.fromTraining;
    }
    if (!!this.updateAssesData && !!this.updateAssesData.assessmentId) {
      await this.fetchData();
      this.fromTraining = true;
      this.assessmentActionCall({ id: this.updateAssesData.assessmentId, action: 'Update' })
    }

  }

  async fetchData() {
    try {
      // ${this.from}
      let res = await this.dataService.getData(`assessment/id/${this.updateAssesData.assessmentId}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.operationAssessment = res.data;

    } catch (e) {

    }
  }

  private async fetchTopics(): Promise<void> {
    let res = await this.dataService.getData(`question-bank/topics/1/1000?type=Topic`);
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.topics = res.data;
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.page = event.page + 1
    this.currentQBankId = "";

    const params = { page: this.page, rows: this.rows };


    this.router.navigate([], {
      relativeTo: this.activatedRouter,
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }

  onTabChange(event: any) {
    this.activeTabIndex = event.index;
    this.router.navigate([], {
      relativeTo: this.activatedRouter,
      queryParams: { tabIndex: this.activeTabIndex },
      queryParamsHandling: 'merge'
    });
  }


  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }

  async getAssessmentTags(ouId?: string) {
    console.log('ALLOWED TAGS', this.allowedTags);
    try {
      let url = 'survey-tags/ASSESSMENT';
      if (ouId) {
        url += `?ou=${ouId}`;
      }
      let res = await this.dataService.getData(url);
      if (res.error) {
        return;
      }
      if (this.allowedTags.includes('MASTER_TAG')) {
        this.allTags = res.data.filter((e: any) => e.tag != 'MASTER_TAG' && e.tag != 'GENERAL_QB').map((data: any) => {
          return {
            _id: data._id,
            label: data.arabic,
            arabic: data.arabic,
            value: data.tag,
            ou: data.ou,
            questionbanks: data.questionbanks || []
          }
        });
      } else {
        this.allTags = res.data.filter((e: any) => this.allowedTags.includes(e.tag) && e.tag != 'GENERAL_QB').map((data: any) => {
          return {
            _id: data._id,
            label: data.arabic,
            arabic: data.arabic,
            value: data.tag,
            ou: data.ou,
            questionbanks: data.questionbanks || []
          }
        });
      }
      this.availableTags = this.allTags;
    } catch (e) {
      console.log(e);
    }
  }

  async getQuestionBanks() {
    if (this.fromTraining) {
      this.allowedTags = ["TAG_10"]
    }
    try {

      let url = `question-bank/list?page=${this.page}&size=${this.rows}&tags=${encodeURIComponent(this.allowedTags.join(','))}`;
      if (this.currentQBankId) {
        url += `&id=${encodeURIComponent(this.currentQBankId)}`;
      }

      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.questionBanks = res.data.data;

      console.log("Current QBank ID", this.currentQBankId);

      // if (!this.currentQBankId) {
      //   this.currentQBank = this.questionBanks[0];
      // } 
      // ;
      console.log("questionBanks", this.questionBanks);

      if (!!this.currentQBankId) {
        this.currentQBank = this.questionBanks.find(e => e._id == this.currentQBankId);
      }
      if (!this.currentQBank && this.fromTraining == false && !this.currentQBankId) {
        this.currentQBankId = "";
        this.router.navigate(['/assessment']);
      }



      const compare = (a: any, b: any) => {
        return b - a;
      }

      //Getting top 10 latest edited or created entries to show by default
      this.assessments = this.questionBanks.flatMap(e => e.assessments).sort((a, b) => compare(new Date(a.updatedAt), new Date(b.updatedAt))).slice(0, 10);

      if (!!this.currentQBank) {
        this.currentQBankId = this.currentQBank._id;
        this.questionBankTopics = this.currentQBank.topics.filter((item: { type: string; }) => item.type === 'Topic');
        this.questionBankService = this.currentQBank.topics.filter((item: { type: string; }) => item.type === 'Service');
        this.assessments = this.currentQBank.assessments;
      }
      this.questionBanks = this.questionBanks.filter(item => item._id !== this.standardQBID);
      this.totalDocuments = res.data.documentCount;

      // Ensure sidebar is synced with newly fetched data
      this.filterQuestionBanks();

    } catch (error) {
      console.log(error);
    }
  }

  async getAllQuestionBanks() {
    try {
      let res = await this.dataService.postData(`question-bank/getAll/${this.allowedTags.join(',')}`, null);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.questionBanksAll = res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getStandardQB() {
    try {
      let res = await this.dataService.getData(`question-bank/${this.standardQBID}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.standardQBs = res.data;
      if (this.currentQBank?.standard && this.standardQBs.length > 0) {
        let StandardQBTopic = this.standardQBs[0].topics.filter((item: { type: string; }) => item.type === 'Topic');
        let StandardQBService = this.standardQBs[0].topics.filter((item: { type: string; }) => item.type === 'Service');
        this.questionBankTopics.push(...StandardQBTopic);
        this.questionBankService.push(...StandardQBService);
      }

      this.ministries = this.questionBankService
        .filter(item => item?.data && item.data.length > 0)
        .map(item => item.data[0]?.ministry)
        .filter((ministry, index, self) =>
          index === self.findIndex(t => (
            t.id === ministry.id
          ))
        );

      this.ministries.forEach((ministry) => {
        const ministryQuestionBanks = this.questionBankService.filter((item: { data: { ministry: { _id: any; }; }[]; }) => {
          return item.data && item.data[0] && item.data[0].ministry && item.data[0].ministry._id === ministry._id;
        });
        const questionBankCount = ministryQuestionBanks.length;
        let subTotalService = 0;
        ministryQuestionBanks.forEach((item: any) => {
          if (item.questions) {
            subTotalService += item.questions.length;
          }
        });
        ministry.total = questionBankCount;
        ministry.subTotal = subTotalService;
      });
    } catch (error) {
      console.log(error);
    }
  }

  changeCurrentQBank(event: any) {
    this.currentQBank = event;
    this.currentQBankId = event?._id;
    if (this.standardQBID == this.currentQBankId) {
      this.links.splice(1, 1);

      console.log("this.links", this.links);

      if (this.HeaderComponent) {
        console.log("asd");
        this.HeaderComponent.ngOnInit();
      }
    }
    
    // Preserve the current filtered question banks so they don't disappear
    this.preserveFilteredQBs = true;
    
    this.skelition = true;
    this.getQuestionBanks()
      .then(() => {
        this.skelition = false;
      })
      .catch((error) => {
        console.error("Error loading question banks:", error);
        this.skelition = false;
      });

    this.router.navigate([], {
      relativeTo: this.activatedRouter,
      queryParams: { QBankId: this.currentQBank._id },
      queryParamsHandling: 'merge'
    });
  }

  getStatusArabic(status: string) {
    switch (status) {
      case this.statusOptions[0]:
        return "مسودة";
      case this.statusOptions[1]:
        return "قيد الانتظار";
      case this.statusOptions[2]:
        return "نشط";
      case this.statusOptions[3]:
        return "غير نشط"
      default:
        return "";
    }
  }

  sortAssessments(field: string) {
    this.sortField = field;
    if (this.sortDirection === 'asc') {
      this.sortDirection = 'desc';
    } else {
      this.sortDirection = 'asc';
    }
    this.assessments.sort((a, b) => {
      if (this.sortDirection === 'asc') {
        if (a[field] < b[field]) return -1;
        if (a[field] > b[field]) return 1;
      } else {
        if (a[field] > b[field]) return -1;
        if (a[field] < b[field]) return 1;
      }
      return 0;
    });
  }

  get filteredAssessments(): any[] {
    let list = this.assessments;
    if (this.statusFilter) {
      list = list.filter((assessment: any) => assessment.status === this.statusFilter);
    }
    if (!this.searchText || this.searchText.trim() === '') {
      return list;
    }
    const searchLower = this.searchText.toLowerCase().trim();
    return list.filter((assessment: any) => {
      // Search in assessment name
      const nameMatch = assessment.name?.toLowerCase().includes(searchLower);
      // Search in question bank name if available
      const qBankMatch = assessment.questionBank?.name?.toLowerCase().includes(searchLower);
      // Search in created by name
      const createdByMatch = this.getName(assessment?.createdBy?.name)?.toLowerCase().includes(searchLower);
      // Search in status
      const statusMatch = this.getStatusArabic(assessment.status)?.toLowerCase().includes(searchLower);
      // Search in comments/description
      const commentsMatch = assessment.comments?.toLowerCase().includes(searchLower);

      return nameMatch || qBankMatch || createdByMatch || statusMatch || commentsMatch;
    });
  }

  onSearchChange() {
    // Update checkbox state based on filtered assessments
    const assessmentsToCheck = this.searchText && this.searchText.trim() !== ''
      ? this.filteredAssessments
      : this.assessments;

    if (assessmentsToCheck.length > 0) {
      const allSelected = assessmentsToCheck.every((s: any) => s.selected);
      this.checkboxValue = allSelected;
    } else {
      this.checkboxValue = false;
    }
  }


  getAssessments = async () => {
    this.assessments = [];
    this.selectedAssessments = [];
    try {
      let res = await this.dataService.getData(`assessment/${this.page}/${this.rows}/${this.allowedTags.join(',')}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.assessments = res.data.data;
      this.totalDocuments = res.data.documentCount
    } catch (error) {
      console.log(error);
    }
  };

  createModal() {
    this.isCopy = 'false';
    this.makequestion();
    this.openCreateModal = true;
  }

  makequestion() {
    let today = new Date()
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: this.translate('Name'),
        required: true,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        className: 'col-md-12 col-sm-12 col-12',
        value: true,
        visibility: "false",

      }),

      new TimePickerQuestion({
        key: 'startDate',
        label: 'تاريخ البدء',
        required: true,
        showTime: true,
        className: 'col-md-12 col-sm-12 col-12',
        visibility: this.fromTraining ? "false" : "true",
        value: this.fromTraining ? new Date() : null,
        touchUI: true
      }),

      new TimePickerQuestion({
        key: 'endDate',
        label: 'تاريخ الانتهاء',
        required: true,
        showTime: true,
        className: 'col-md-12 col-sm-12 col-12',
        visibility: this.fromTraining ? "false" : "true",
        touchUI: true,
        value: this.fromTraining ? new Date(today.getFullYear() + 1, today.getMonth(), today.getDate(), 0, 0, 0) : null
      }),

      new TextEditorQuestion({
        key: 'comments',
        label: 'الوصف',
        className: 'col-md-12 col-sm-12 col-12',
        visibility: "true",
      }),

      new DropdownQuestion({
        key: 'cloneQuestionBankId',
        label: 'المسارات',
        options: this.questionBanksAll.map(e => { return { label: e.name + ' (' + e.tag.arabic + ')', value: e._id } }),
        className: 'col-12',
        visibility: this.isCopy,
        value: this.assessmentTypeId
      }),

      new RadioButtonQuestion({
        key: 'accessType',
        label: 'النوع',
        options: [
          { label: this.translate('Through Knowledge Portal Users'), icon: 'pi pi-account', value: 'BY_ACCOUNT' },
          { label: this.translate('BY_LINK'), icon: 'pi pi-web', value: 'BY_URL' },
        ],
        visibility: (!this.fromTraining).toString(),
        className: 'col-md-12 col-sm-12 col-12',
        value: 'BY_ACCOUNT'
      }),

      new RadioButtonQuestion({
        key: 'copyType',
        label: this.translate('Copy Settings'),
        options: [
          { label: this.translate('ONLY_QUESTIONS'), icon: 'pi pi-web', value: 'ONLY_QUESTIONS' },
          { label: this.translate('SETTINGS_AND_QUESTIONS'), icon: 'pi pi-account', value: 'SETTINGS_AND_QUESTIONS' },
        ],
        visibility: this.isCopy,
        className: 'col-md-12 col-sm-12 col-12',
        value: 'ONLY_QUESTIONS'
      }),

      new TextboxQuestion({
        key: 'allowedAttempts',
        label: this.translate("allowedAttempts"),
        required: false,
        order: 1,
        icon: 'pi pi-file',
        visibility: this.fromTraining ? "true" : "false",
        className: 'col-12',
      }),

      new CheckBoxQuestion({
        key: 'anonymous',
        label: 'إخفاء هوية المشارك',
        required: false,
        order: 1,
        className: 'col-md-6 col-sm-12 col-12',
        value: false
      }),
    ];
  }

  openAssessmentMenu(menu: any, event: any, assessment: any) {
    this.operationAssessment = assessment;
    console.log(this.operationAssessment)
    menu.toggle(event);
  }

  receiveAssessmentData = async ($event: any) => {
    try {
      let data = $event;
      data.testType = SurveyAssessment.ASSESSMENT;

      if (data.cloneQuestionBankId) {
        data.questionBankId = data.cloneQuestionBankId;
      }
      else if (this.assessmentTypeId) {
        data.questionBankId = this.assessmentTypeId;
      }
      else {
        data.questionBankId = this.currentQBank._id;
      }

      if (data.startDate.getTime() > data.endDate.getTime() || data.endDate.getTime() < data.startDate.getTime()) {
        console.log("Start data should be less than end date 3");
        this.messageService.add({
          severity: 'error',
          summary: this.translate('error'),
          detail: this.translate('Start data should be less than end date')
        });
        return;
      }

      this.clonedAssessment.percentageCriteria

      if (this.clonedAssessment) {
        if (data.copyType == 'ONLY_QUESTIONS') {
          // Copy questions and basic scoring settings
          data.questions = this.clonedAssessment.questions;
          data.defaultScore = this.clonedAssessment.defaultScore;
          data.totalMarks = this.clonedAssessment.totalMarks;
        }
        else {
          // Copy all questions and external questions
          data.questions = this.clonedAssessment.questions;
          data.externalQuestions = this.clonedAssessment.externalQuestions;
          data.topics = this.clonedAssessment.topics;

          // Copy all settings
          data.settings = this.clonedAssessment.settings;
          data.percentageCriteria = this.clonedAssessment.percentageCriteria;
          data.isCopy = true
          data.certificateMinistry = this.clonedAssessment.certificateMinistry;
          data.showResult = this.clonedAssessment.showResult;
          data.showCert = this.clonedAssessment.showCert;

          // Copy scoring settings
          data.defaultScore = this.clonedAssessment.defaultScore;
          data.totalMarks = this.clonedAssessment.totalMarks;

          // Copy UI/text settings
          data.footerText = this.clonedAssessment.footerText;
          data.headerImage = this.clonedAssessment.headerImage;
          data.thankyouPageText = this.clonedAssessment.thankyouPageText;

          // Copy external fields
          data.externalFields = this.clonedAssessment.externalFields;
          data.attemptTime = this.clonedAssessment.attemptTime;
          data.totalParticipant = this.clonedAssessment.totalParticipant

        }
      }
      data.startDate = formatDate(data.startDate, "dd-MM-yyyy HH:mm", this.locale);
      data.endDate = formatDate(data.endDate, "dd-MM-yyyy HH:mm", this.locale);

      if (this.fromTraining) {
        data.trainingTypeId = this.trainingTypeId;
      }

      let res = await this.dataService.postData('assessment', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      if (this.fromTraining) this.newAssess.emit(res);
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.DynamicFormComponent.resetForm();
      this.openCreateModal = false;
      this.isCopy = 'false'
      this.clonedAssessment = {};
      this.ngOnInit()
    } catch (error) {
      console.log(error);
    }
  };


  createGroup = async (ids: any) => {
    try {
      let data: any = {
        assessmentIds: ids
      }
      let res = await this.dataService.postData('assessment-group', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.selectedAssessments = [];
      this.ngOnInit()
    } catch (error) {
      console.log(error);
    }
  };

  updateAssessmentData = async (event: any) => {
    console.log('EVENT IS', event);

    try {
      let data: any = event;
      let startDateTime: Date;
      let endDateTime: Date;

      // Parse dates regardless of format
      if (typeof data.startDate === 'string') {
        startDateTime = this.parseDate(data.startDate);
      } else {
        startDateTime = data.startDate;
      }

      if (typeof data.endDate === 'string') {
        endDateTime = this.parseDate(data.endDate);
      } else {
        endDateTime = data.endDate;
      }

      // Validate that start date is before end date
      if (startDateTime.getTime() >= endDateTime.getTime()) {
        this.messageService.add({
          severity: 'error',
          summary: this.translate('error'),
          detail: this.translate('Start data should be less than end date')
        });
        return;
      }
      if (typeof data.startDate != 'string') {
        data.startDate = formatDate(data.startDate, "dd-MM-yyyy HH:mm", this.locale);
      }
      if (typeof data.endDate != 'string') {
        data.endDate = formatDate(data.endDate, "dd-MM-yyyy HH:mm", this.locale);
      }
      if (this.updateData) {
        data._id = this.updateData._id;
      }

      if (!!this.currentQBank) {
        data.questionBankId = this.currentQBank._id;
      } else {
        let qb = this.questionBanks.find(e => (e.assessments as Array<any>).some(f => f._id == data._id));
        data.questionBankId = qb._id;
      }

      if (typeof data.status != 'string') {
        data.status = data.status.label;
      }
      let res = await this.dataService.postData(
        'assessment',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      if (this.fromTraining) this.updateAssesment.emit(res);
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      // updating in table
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  };

  markAll() {
    // Only mark filtered assessments when searching
    const assessmentsToMark = this.searchText && this.searchText.trim() !== ''
      ? this.filteredAssessments
      : this.assessments;

    assessmentsToMark.forEach((s: any) => {
      s.selected = this.checkboxValue;
    });

    if (this.checkboxValue) {
      this.selectedAssessments = [...assessmentsToMark];
    } else {
      // Unselect all assessments, not just filtered ones
      this.assessments.forEach((s: any) => {
        s.selected = false;
      });
      this.selectedAssessments = [];
    }
  }

  selectAssessment(assessment: any, value: boolean) {
    assessment.selected = value;
    if (assessment.selected) {
      this.selectedAssessments.push(cloneDeep(assessment));
    } else {
      this.selectedAssessments = this.selectedAssessments.filter(e => e._id != assessment._id)
    }
  }

  async bulkDelete() {

    try {
      let ids = this.selectedAssessments.map((s: any) => s._id);
      let res = await this.dataService.postData(`assessment/bulkdelete`, { 'ids': ids }, 'POST', false);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.selectedAssessments = []
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  }

  getTransformedDate(dateTime: string): string {
    const [datePart, timePart] = dateTime.split(' ');
    const [day, month, year] = datePart.split('-').map(Number);
    const dateObj = new Date(year, month - 1, day);
    let formattedDate = new DatePipe(this.locale, 'Asia/Riyadh').transform(dateObj);
    if (timePart) {
      const [hours, minutes] = timePart.split(':').map(Number);
      const timeObj = new Date(0, 0, 0, hours, minutes);
      const formattedTime = new DatePipe(this.locale).transform(timeObj, 'HH:mm');
      formattedDate += ' ' + formattedTime;
    }
    return formattedDate || '';
  }

  assessmentActionCall($event: any) {
    switch ($event.action) {
      case 'Results':
        let ids = this.selectedAssessments.map((s: any) => s._id);
        this.router.navigate(['/assessment/all-results'], { queryParams: { ids: ids } });
        console.log('PERMISSION C route to results')
        break;
      case 'Group':
        this.createGroup(this.selectedAssessments.map((s: any) => s._id));
        break;
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => {
            if ($event.bulk) {
              this.bulkDelete();
            } else {
              this.deletetAssessment($event.id);
            }
          },
        });
        break;
      case 'Update':
        this.updateData = this.operationAssessment;
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: this.translate('Name'),
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-12',
          }),

          new TimePickerQuestion({
            key: 'startDate',
            label: 'تاريخ البدء',
            required: true,
            showTime: true,
            className: 'col-6',
            visibility: this.fromTraining ? "false" : "true",
            value: this.updateData.startDate,
            touchUI: true
          }),

          new TimePickerQuestion({
            key: 'endDate',
            label: 'تاريخ الانتهاء',
            required: true,
            showTime: true,
            className: 'col-6',
            visibility: this.fromTraining ? "false" : "true",
            value: this.updateData.endDate,
            touchUI: true
          }),

          new DropdownQuestion({
            key: 'status',
            label: 'الحالة',
            required: true,
            options: this.statusOptions.map(e => { return { label: this.getStatusArabic(e), value: e } }),
            className: 'col-12',
            visibility: "true",
            value: this.updateData.status
          }),

          new TextEditorQuestion({
            key: 'comments',
            label: 'الوصف',
            className: 'col-12',
            visibility: "true",
            value: this.updateData.comments
          }),

          new RadioButtonQuestion({
            key: 'accessType',
            label: 'النوع',
            options: [
              { label: this.translate('Through Knowledge Portal Users'), icon: 'pi pi-account', value: 'BY_ACCOUNT' },
              { label: this.translate('BY_LINK'), icon: 'pi pi-web', value: 'BY_URL' },
            ],
            visibility: "true",
            className: 'col-12',
            value: this.updateData.accessType
          }),

          new DropdownQuestion({
            key: 'active',
            label: 'الحالة',
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            className: 'col-md-12 col-sm-12 col-12',
            value: true,
            visibility: "false",

          }),

          new TextboxQuestion({
            key: 'allowedAttempts',
            label: this.translate("allowedAttempts"),
            required: false,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.allowedAttempts,
            visibility: this.fromTraining ? "true" : "false",
            className: 'col-12',
          }),

          new CheckBoxQuestion({
            key: 'anonymous',
            label: 'إخفاء هوية المشارك',
            required: false,
            order: 1,
            className: 'col-md-6 col-sm-12 col-12',
            value: this.updateData.anonymous || false
          }),

          new functionLink({

            label: this.translate('Copy Link'),
            icon: 'pi pi-copy',
            function: () => {
              console.log('Copy Link Function Called');
              const copyText = `${window.location.origin}/sa/assessment/attempt/${this.updateData._id}`;
              navigator.clipboard.writeText(copyText).then(() => {
                this.messageService.add({
                  severity: 'success',
                  summary: this.translate('Link copied successfully'),
                });
              }).catch(err => {
                console.error('Failed to copy link: ', err);
                this.messageService.add({
                  severity: 'error',
                  summary: this.translate('Failed to copy link'),
                });
              });
            }

          })
        ];
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  getName(name: any) {
    if (!!name) {
      return name?.first + " " + name?.middle + " " + name?.last;
    }
    return "-"
  }

  deletetAssessment = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`assessment/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  };

  setCloneQestions(assessment: any, questionBankId: any) {
    this.assessmentTypeId = questionBankId;
    this.isCopy = 'true';
    this.makequestion();
    this.openCreateModal = true;
    this.clonedAssessment = assessment;
  }

  onDialogClose() {
    this.clonedAssessment = {};
    this.isCopy = 'false';
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  /**
   * Navigate back to assessment page when currentQBankId equals standardQBID
   */
  navigateToAssessment(): void {
    window.location.href = '/assessment';
  }

  private parseDate(dateString: string): Date {
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('-').map(Number);
    const [hours, minutes] = timePart ? timePart.split(':').map(Number) : [0, 0];
    return new Date(year, month - 1, day, hours, minutes);
  }

  // Getters for statistics
  get totalAttemptsCount(): number {
    const list = this.currentQBank ? (this.currentQBank.assessments || []) : this.questionBanks.flatMap(e => e.assessments || []);
    return list.reduce((sum: number, item: any) => sum + (item.attempts || 0), 0);
  }

  get draftAssessmentsCount(): number {
    const list = this.currentQBank ? (this.currentQBank.assessments || []) : this.questionBanks.flatMap(e => e.assessments || []);
    return list.filter((item: any) => item.status === 'Draft').length;
  }

  get activeAssessmentsCount(): number {
    const list = this.currentQBank ? (this.currentQBank.assessments || []) : this.questionBanks.flatMap(e => e.assessments || []);
    return list.filter((item: any) => item.status === 'Active').length;
  }

  get totalAssessmentsCount(): number {
    const list = this.currentQBank ? (this.currentQBank.assessments || []) : this.questionBanks.flatMap(e => e.assessments || []);
    return list.length;
  }

  // Getters for client-side pagination
  get paginatedAssessments(): any[] {
    const startIndex = (this.page - 1) * this.rows;
    return this.filteredAssessments.slice(startIndex, startIndex + this.rows);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredAssessments.length / this.rows) || 1;
  }

  get pagesArray(): number[] {
    const total = this.totalPages;
    const current = this.page;
    const pages: number[] = [];
    
    if (total <= 5) {
      for (let i = 1; i <= total; i++) pages.push(i);
    } else {
      if (current <= 3) {
        for (let i = 1; i <= 4; i++) pages.push(i);
      } else if (current >= total - 2) {
        for (let i = total - 3; i <= total; i++) pages.push(i);
      } else {
        for (let i = current - 1; i <= current + 2; i++) pages.push(i);
      }
    }
    return pages;
  }

  setPage(p: number) {
    if (p >= 1 && p <= this.totalPages) {
      this.page = p;
      this.checkboxValue = false;
    }
  }

  prevPage() {
    if (this.page > 1) {
      this.setPage(this.page - 1);
    }
  }

  nextPage() {
    if (this.page < this.totalPages) {
      this.setPage(this.page + 1);
    }
  }

  onRowsChange(newRows: any) {
    this.rows = Number(newRows);
    this.page = 1;
    this.checkboxValue = false;
  }

  get pageStart(): number {
    if (this.filteredAssessments.length === 0) return 0;
    return (this.page - 1) * this.rows + 1;
  }

  get pageEnd(): number {
    return Math.min(this.page * this.rows, this.filteredAssessments.length);
  }

  get qbMenuItems(): MenuItem[] {
    return this.filteredQuestionBanks.map((qb: any) => ({
      label: qb.name,
      command: () => {
        this.changeCurrentQBank(qb);
      }
    }));
  }

  get statusFilterMenuItems(): MenuItem[] {
    return this.statusOptions.map((status: any) => ({
      label: this.getStatusArabic(status),
      command: () => {
        this.statusFilter = status;
        this.checkboxValue = false;
        this.page = 1;
      }
    }));
  }

  clearStatusFilter(event: Event) {
    event.stopPropagation();
    this.statusFilter = null;
    this.checkboxValue = false;
    this.page = 1;
  }

  clearQBankFilter(event: Event) {
    event.stopPropagation();
    this.clearFilters();
  }

  clearAllFilters() {
    this.statusFilter = null;
    this.searchText = '';
    this.clearFilters();
  }

  get qbDropdownOptions(): any[] {
    return this.filteredQuestionBanks.map((qb: any) => ({
      label: qb.name,
      value: qb
    }));
  }

  get statusDropdownOptions(): any[] {
    return this.statusOptions.map((status: any) => ({
      label: this.getStatusArabic(status),
      value: status
    }));
  }

  onQBankDropdownChange(event: any) {
    const selectedQBank = event.value;
    if (selectedQBank) {
      this.changeCurrentQBank(selectedQBank);
    } else {
      this.clearFilters();
    }
  }

  onStatusDropdownChange(event: any) {
    this.checkboxValue = false;
    this.page = 1;
  }
}
